var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dogesays"},[_c('transition',{attrs:{"name":"dogesay"}},[_c('div',{key:this.happ,staticClass:"saying",style:(this.happStyle())},[_vm._v(_vm._s(this.getSaying()))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }